<template>
  <div>
    <el-alert
      v-if="trackList.length > 3"
      style
      show-icon
      title="监测代码数量已超过3条"
      type="warning">
    </el-alert>
    <el-row :gutter="4" :key="index" v-for="(item, index) in trackList" style="margin-bottom: 10px;">
      <el-col>
        <el-col :span="4">
          <el-select v-if="trackTypeList.length > 0" :disabled="item.trackDisabled" v-model="item.trackType"
            @change="item.trackTypeModel = undefined">
            <el-option :key="idx" v-for="(opt, idx) in trackTypeList" :value="opt.key" :label="opt.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select :disabled="item.trackDisabled" v-model="item.trackTypeModel" placeholder="类型"
            @change="trackTypeModelHandle(item)">
            <el-option :key="idx" v-for="(opt, idx) in trackTypeModelOpts(item)" :value="opt.key"
              :label="opt.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select :disabled="item.trackDisabled" v-model="item.serviceProvider"
            @change="handleInputProvider(item, $event, index)" placeholder="监测商">
            <el-option :key="idx" v-for="(opt, idx) in item.trackTypeModel === 2 ? sdkProviderList : providerList"
              :value="opt.providerNo" :label="opt.providerName">
            </el-option>
          </el-select>
        </el-col>
        <el-col v-if="showPointInput" :span="3">
          <el-autocomplete
            v-model="item.point"
            readonly
            placeholder="时间"
            :disabled="item.trackDisabled"
            :fetch-suggestions="querySearch"
            @select="() => handlePointSelect(item)"
            @focus="focusedPointValue = item.point"
          >
            <span slot="append">秒</span>
          </el-autocomplete>
        </el-col>
        <el-col :span="showPointInput ? 8 : 11">
          <el-input v-model.trim="item.code" placeholder="请输入监测代码" @change="checkCode(item, index)" :disabled="item.trackDisabled" />
        </el-col>
        <el-col :span="2">
          <el-popover placement="top" width="160" trigger="manual" :value="index === deletePopoverIndex">
            <p>清空这行内容？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="cancelPopover">取消</el-button>
              <el-button type="primary" size="mini" @click="delTrack(index)">确定</el-button>
            </div>
            <el-button slot="reference" :disabled="item.trackDisabled"
              @click.stop="changePopoverStatus(index)">删除</el-button>
          </el-popover>
        </el-col>
      </el-col>
      <el-col>
        <div v-if="item.codeMessage" style="color: red;font-size: 12px">
          <el-col :offset="11">{{ item.codeMessage }}</el-col>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <div style="margin-top: 10px;">
        <el-button type="primary" size="small" @click="addTrack()">
          <i class="ion-plus-round"></i>
          添加代码
        </el-button>
        <el-button :disabled="isDisable" v-if="trackKey !== '' && !showPointInput" type="primary" size="small" @click="addCoocaaTrack()">
          <i class="ion-plus-round"></i>
          添加自有监测
        </el-button>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deletePopoverIndex: undefined,
      visibleArray: [],
      isDisable: false,
      focusedPointValue: undefined,
      ownTrack: null,
    }
  },
  props: {
    trackList: { type: Array, default: () => [] },
    providerList: { type: Array, default: () => [] },
    trackKey: { type: String, default: '' },
    trackTypeList: { type: Array, default: () => [] },
    sdkProviderList: { type: Array, default: () => [] },
    pointList: { type: Array, default: () => [] },
    supportPointTrack: { type: Boolean, default: false },
  },
  computed: {
    trackTypeModelOpts(item) {
      return function (item) {
        if (this.trackTypeList.length === 0) {
          return [
            { key: 1, value: 'API' },
            { key: 2, value: 'SDK' }
          ]
        }
        const trackTypeObj = this.trackTypeList.find(opt => item.trackType === opt.key)
        return trackTypeObj ? trackTypeObj.sub : []
      }
    },
    showPointInput() {
      return this.supportPointTrack === true && this.trackKey === 'track_point'
    },
  },
  methods: {
    querySearch(query, cb) {
      cb(this.pointList)
    },
    trackTypeModelHandle(item) {
      const providerList = item.trackTypeModel === 2 ? this.sdkProviderList : this.providerList
      if (providerList.every(provider => provider.providerNo !== item.serviceProvider)) {
        item.serviceProvider = ''
      }
    },
    changePopoverStatus(index) {
      this.deletePopoverIndex = index
    },
    cancelPopover() {
      this.deletePopoverIndex = undefined
    },
    checkCode(track, index) {
      let codeMessage = ''
      const provider = this.providerList.find(item => item.providerNo === track.serviceProvider)
      if (!track.code) {
        this.$set(this.trackList[index], 'codeMessage', '')
        return
      }
      // 校验是否有加密参数
      if (provider && provider.secret === 1 && provider.secretParam) {
        let params = provider.secretParam.split(',')
        if (!params.some(p => track.code.includes(p))) {
          codeMessage += '监测代码缺少加密参数'
        }
      }
      // 秒针代码非创维智能电视监测代码
      if (track.serviceProvider === 'miaozhen' && !track.code.includes('m=13')) {
        codeMessage = codeMessage ? (codeMessage + '，且秒针代码非创维智能电视监测代码') : '秒针代码非创维智能电视监测代码'
      }
      if (codeMessage) {
        codeMessage += '，建议与销售确认后送审'
      }
      this.$set(this.trackList[index], 'codeMessage', codeMessage)
    },
    // 监测商发生变化时更新结算监测商列表
    handleInputProvider(item, val, index) {
      item.serviceProvider = val
      this.checkCode(item, index)
    },
    // 删除监测代码
    delTrack(index) {
      this.trackList.splice(index, 1)
      this.deletePopoverIndex = undefined
    },
    addTrack() {
      this.trackList.push({
        trackType: 1,
        serviceProvider: '', // 监测商
        trackTypeModel: undefined, // 监测方式
        code: '', // 监测代码
        trackDisabled: false// 是否禁用
      })
    },
    addCoocaaTrack() {
      if (this.ownTrack) {
        this.addOwnTrack()
      } else {
        this.isDisable = true
        this.$service
          .getCoocaaTrack({ trackType: this.trackKey })
          .then((res) => {
            if (res) {
              this.isDisable = false
              this.ownTrack = res
              this.addOwnTrack()
            } else {
              this.isDisable = false;
              return this.$message.error('未获取到自有监测代码')
            }
          })
      }
    },
    addOwnTrack() {
      this.trackList.push({
        trackType: 1,
        serviceProvider: this.ownTrack.provider, // 监测商
        trackTypeModel: undefined, // 监测方式
        code: this.ownTrack.code, // 监测代码
        trackDisabled: false// 是否禁用
      })
    },
    handlePointSelect(item) {
      const trackList = this.trackList.filter(track => item.point && item.point === track.point)
      if (trackList.length > 1) {
        const curValue = item.point
        item.point = this.focusedPointValue
        this.$confirm('定点监测-时间重复，确认选择吗?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          center: true,
          showClose: false
        })
          .then(() => {
            item.point = curValue
          })
          .catch(() => {})
      }
    },
  },
  created() {
  }
}
</script>

<style lang="stylus" scoped>
.el-alert
  margin-bottom 10px
  line-height 18px
>>>.el-input-group__append
  padding 0 10px
</style>
